/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import React, {Component} from 'react';

import {DragDropContext, Droppable} from 'react-beautiful-dnd';
import {MESSAGES} from '../../../../constants/APP_CONSTANTS';
import AxiosClient from "../../../../_helpers/http.helper";
import urlHelper from "../../../../_helpers/url.format.server.helper";
import config from "../../../../config";

import Table from './ChapterComponents/Table';

import {
    reorder,
    reArrange,
    reorderResourceInstances,
    titleArray,
    buildChapterPayload,
    getChapterId
} from './ChapterComponents/HelperMethods/DragAndDropHelper';


export default class ChapterWrapper extends Component {

    constructor(props) {
        super(props);
        const columns = props.activeCollection.chapters ? reArrange(props.activeCollection.chapters): [];
        const chapterId = props.activeCollection.chapters ? titleArray(props.activeCollection.chapters) : [];
        this.state = {
            columns: props.activeCollection.chapters ? columns : [],
            titles: props.activeCollection.chapters ? Object.keys(columns) : [],
            chapterId: props.activeCollection.chapters ? chapterId : [],
            freeze: false
        };
    }

    componentWillReceiveProps(nextProps) {
        if (typeof nextProps.activeCollection.chapters === 'object') {
            const columns = nextProps.activeCollection.chapters ? reArrange(nextProps.activeCollection.chapters): [];
            const chapterId = nextProps.activeCollection.chapters ? titleArray(nextProps.activeCollection.chapters) : [];
            if (nextProps.activeCollection.chapters !== this.props.activeCollection.chapters) {
                this.setState({
                    columns: columns,
                    titles: Object.keys(columns),
                    chapterId: chapterId
                });
                this.freezeDiv(false);
            }
        }
    }


    getCollectionNote(pearsonResourceType, activeCollection) {
        let collectionNotes = {};
        switch (pearsonResourceType) {
            case "OM":
                collectionNotes = this.createCollectionNote(MESSAGES["book_has_om"], activeCollection);
                break;
            case "BluePrint":
                collectionNotes = this.createCollectionNote(MESSAGES["book_has_blueprint_msg_part1"] + activeCollection.isbn + MESSAGES["book_has_blueprint_msg_part2"], activeCollection);
                break;
            case "PrintRental":
                collectionNotes = this.createCollectionNote(MESSAGES["print_rental_content_match"], activeCollection);
        }
        return collectionNotes;
    }

    createCollectionNote(message, activeCollection) {
        return {
            body: message,
            collection: activeCollection,
            collectionNoteHolds: [],
        };
    }

    addNote = (pearsonResourceType, activeCollection) => {
        const url = urlHelper.formatUrl(
            config.collectionService.baseUrl,
            config.collectionService.routes.addNote,
        );
        let collectionNotes = this.getCollectionNote(pearsonResourceType, activeCollection);

        AxiosClient.post(url, collectionNotes)
            .then(() => {
                console.log("Success");
            })
            .catch(error => {
                console.log("Error ", error);
            });
    };

    freezeDiv = (boolValue) => {
        this.setState({
            freeze:boolValue
        });
    };

    onDragEnd = (result) => {

        // dropped nowhere
        if (!result.destination) {
            return;
        }

        const source = result.source;
        const destination = result.destination;

        // did not move anywhere - can bail early
        if (source.droppableId === destination.droppableId && source.index === destination.index) {
            return;
        }

        // reordering column
        if (result.type === 'COLUMN') {

            const ReOrderedCollums = reorder(
                this.state.titles,
                source.index,
                destination.index
            );

            this.setState({
                titles: ReOrderedCollums,
            });

            const chapterId = getChapterId(this.state.chapterId, result.draggableId);

            const updateChapterUrl = urlHelper.formatUrl(
                config.collectionService.baseUrl,
                config.collectionService.routes.updateChapter,
                {
                    collectionId: this.props.activeCollection.collectionId,
                    chapterId: chapterId,
                    sequence: result.destination.index
                }

            );

            AxiosClient.put(updateChapterUrl)
                .then(response => {

                    this.props.loadCollection(this.props.activeCollection.collectionId);
                });

            this.freezeDiv(true);
            return;
        }

        const data = reorderResourceInstances({
            resource: this.state.columns,
            source,
            destination,
            titles: this.state.titles
        });

        if (typeof data.titles === 'undefined'){
            this.setState({
                columns: data.resource
            });

            const payload = buildChapterPayload(this.state);
            const updateChapterResourcesUrl = urlHelper.formatUrl(
                config.collectionService.baseUrl,
                config.collectionService.routes.updateChapterResources,
                {
                    collectionId: this.props.activeCollection.collectionId,
                }

            );

            AxiosClient.put(updateChapterResourcesUrl, payload)
                .then(response => {

                    this.props.loadCollection(this.props.activeCollection.collectionId);
                });

            this.freezeDiv(true);


        }else{
            this.setState({
                columns: data.resource,
                titles: data.titles
            });

            const payload = buildChapterPayload(this.state);
            const updateChapterResourcesUrl = urlHelper.formatUrl(
                config.collectionService.baseUrl,
                config.collectionService.routes.updateChapterResources,
                {
                    collectionId: this.props.activeCollection.collectionId,
                }

            );

            AxiosClient.put(updateChapterResourcesUrl, payload)
                .then(response => {

                    this.props.loadCollection(this.props.activeCollection.collectionId);
                });

            this.freezeDiv(true);

        }

    };


    render() {
        const chapters = this.state.columns;
        const titles = this.state.titles;
        const chapterResources = this.props.chapterResources;
        const board = (
            <Droppable
                droppableId={'mainDropZone'}
                type="COLUMN"
                direction="vertical"
            >

                {(provided) => (

                    <div>
                        <label className="pe-title--small">Components</label>
                        <p>To rearrange components, drag and drop them into position or change the numbers in the available fields.</p>
                        <div ref={provided.innerRef} {...provided.droppableProps}>
                            {titles.map((chapter, index) => (

                                <Table
                                    chapter={chapters[chapter]}
                                    chapterResources={chapterResources}
                                    index={index}
                                    title={chapter}
                                    key={chapter}
                                    collectionType = {this.props.activeCollection.collectionType}
                                    collectionId = {this.props.activeCollection.collectionId}
                                    loadCollection = {this.props.loadCollection}
                                    showAddContentComponent = {this.props.showAddContentComponent}
                                    activeCollection = {this.props.activeCollection}
                                    freezeUi = {this.freezeDiv}
                                    permissions={this.props.permissions}
                                />
                            ))}

                        </div>
                    </div>
                )

                }

            </Droppable>

        );

        return (

            <div>
                <div className={this.state.freeze?"DragAndDropZone freeze": "DragAndDropZone" }>
                    <div className={this.state.freeze? "loader":"hideLoader"}></div>
                    <DragDropContext
                        onDragStart={this.onDragStart}
                        onDragEnd={this.onDragEnd}
                    >
                        {board}
                    </DragDropContext>
                </div>
            </div>

        );
    }

}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/ComponentPageComponents/ChapterWrapper.js